import React from 'react';

interface NewsAuthor {
  name: string;
  image: string;
  role?: string;
}

interface NewsItem {
  image: string;
  category: string;
  date: string;
  title: string;
  description?: string;
  author: NewsAuthor;
  link: string;
}

interface KidsaNewsProps {
  subtitle?: string;
  title?: string;
  featuredNews: NewsItem;
  additionalNews: NewsItem[];
  seeAllLink?: string;
}

const KidsaNews: React.FC<KidsaNewsProps> = ({
  subtitle,
  title,
  featuredNews,
  additionalNews,
  seeAllLink
}) => {
  return (
    <section className="news-section section-padding fix" id="noticias">
      <div className="container">
        <div className="section-title-area">
          <div className="section-title">
            <span className="wow fadeInUp text-transform-none">{subtitle}</span>
            <h2 
              className="wow fadeInUp text-transform-none" 
              data-wow-delay=".3s"
            >
              {title}
            </h2>
          </div>
          {seeAllLink && (
            <a 
              href={seeAllLink} 
              className="theme-btn wow fadeInUp" 
              data-wow-delay=".5s"
            >
              Ver todas <i className="fa-solid fa-arrow-right-long"></i>
            </a>
          )}
        </div>
        <div className="news-wrapper">
          <div className="row align-items-center text-transform-none">
            <div className="col-xl-6 col-lg-6 wow fadeInUp text-transform-none" data-wow-delay=".3s">
              <div className="news-single-items">
                <div className="news-image">
                  <img src={featuredNews.image} alt="news-img" />
                </div>
                <div className="news-content text-transform-none">
                  <ul>
                    <li>
                      <i className="fas fa-tag"></i> {featuredNews.category}
                    </li>
                    <li>
                      <i className="fa-solid fa-calendar-days"></i> {featuredNews.date}
                    </li>
                  </ul>
                  <h3>
                    <a className="text-transform-none" href={featuredNews.link}>{featuredNews.title}</a>
                  </h3>
                  {featuredNews.description && (
                    <p className="text-transform-none">{featuredNews.description}</p>
                  )}
                  <div className="post-author-items">
                    <div className="post-items">
                      <div className="thumb">
                        <img src={featuredNews.author.image} alt="img" />
                      </div>
                      <div className="contentx">
                        <span>Por {featuredNews.author.role || 'Admin'}</span>
                        <h6>{featuredNews.author.name}</h6>
                      </div>
                    </div>
                    <a href={featuredNews.link} className="theme-btn">
                      Leer más... <i className="fa-solid fa-arrow-right-long"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-8 mt-5 mt-xl-0 news-resume-items">
              {additionalNews.map((news, index) => (
                <div 
                  key={index} 
                  className={`news-right-items wow fadeInUp ${index === additionalNews.length - 1 ? '' : 'mb-4'}`} 
                  data-wow-delay={`.${(index + 4) * 0.1}s`}
                >
                  <div className="news-thumb">
                    <img src={news.image} alt="img" />
                  </div>
                  <div className="news-content">
                    <ul>
                      <li>
                        <i className="fas fa-tag"></i> {news.category}
                      </li>
                      <li>
                        <i className="fa-solid fa-calendar-days"></i> {news.date}
                      </li>
                    </ul>
                    <h3>
                      <a className="text-transform-none" href={news.link}>{news.title}</a>
                    </h3>
                    <div className="post-items">
                      <div className="thumb">
                        <img src={news.author.image} alt="img" />
                      </div>
                      <div className="contentx">
                        <span>Por {news.author.role || 'Admin'}</span>
                        <h6>{news.author.name}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};  

export default KidsaNews;
